import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Box, Divider, Flex, useColorMode } from "@chakra-ui/react";
import "./ActionBar.css";
import LogoComponent from "../Logo/LogoComponent";

const ActionBar = ({ actionBarItems, toggleMenuCollapse }) => {
  const { colorMode } = useColorMode();

  return (
    <Box width="100%">
      <Box
        width="100%"
        minHeight="48px"
        className={`action-bar ${
          colorMode === "light" ? "light-mode" : "dark-mode"
        }`}
      >
        <Flex alignItems="center" justifyContent="space-between" padding="0" width="100%">
          {/* Left Section: Burger Icon and Left-Aligned Items */}
          <Flex alignItems="center">
            <div className="burger-icon" onClick={toggleMenuCollapse}>
              <FontAwesomeIcon icon={faBars} className="burger-icon-svg"/>
            </div>
            {actionBarItems
              .filter((item) => item.align !== "right")
              .map((item, index) => (
                <Box key={index} ml={index === 0 ? 0 : 4} whiteSpace="nowrap">
                  {item.component}
                </Box>
              ))}
          </Flex>

          {!actionBarItems?.length && <Flex className="logo-action-bar" justifyContent="center" alignItems="center" flex="1">
            <LogoComponent isCollapsed={false} height={"35px"}/>
          </Flex>}

          {/* Right Section: Right-Aligned Items */}
          <Flex alignItems="center" ml="auto">
            {actionBarItems
              .filter((item) => item.align === "right")
              .map((item, index) => (
                <Box key={index} ml={4} whiteSpace="nowrap">
                  {item.component}
                </Box>
              ))}
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default ActionBar;
